// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"8155ae1a","19":"7cedee66","79":"f3501218","256":"31847674","286":"5205a8df","318":"efe29a95","453":"1fcecba2","477":"f79716ae","834":"334a1c38","864":"9b9136ac","917":"8d050c29"}[chunkId] + ".chunk.js";
};